'use client';

import { NestedFormDrawer } from '../NestedFormDrawer';
import { OwnerSubForm, type OwnerSubFormProps } from './OwnerSubForm';

interface OwnerSubFormDrawerProps extends OwnerSubFormProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
}

/** The sub-form on its own, for the flows that have no sheet to sit inside. */
export const OwnerSubFormDrawer = ({
  isOpen,
  onClose,
  title,
  ...subForm
}: OwnerSubFormDrawerProps) => (
  <NestedFormDrawer isOpen={isOpen} close={onClose} title={title}>
    <OwnerSubForm {...subForm} onClose={onClose} />
  </NestedFormDrawer>
);
